import cx from 'classnames'
import Select, { Options } from 'react-select'

import {
  getInputSearchDropdownStyles,
  SearchDropdownOption,
  StyleOverrides,
} from '@lib/dom'

import Icon from './icon'

interface InputSearchDropdownProps {
  id: string
  options: Options<SearchDropdownOption>
  value: string
  onChange: (value: string) => void
  errorMessage?: string
  label?: string
  placeholder?: string
  className?: string
  hasBorder?: boolean
  styles?: StyleOverrides
}

const InputSearchDropdown = ({
  id,
  options,
  value,
  onChange = () => null,
  errorMessage,
  label,
  placeholder,
  className,
  hasBorder = true,
  styles,
}: InputSearchDropdownProps) => {
  return (
    <div className={cx('grid', className)}>
      <div className="flex flex-col relative text-left">
        {!!label && (
          <label htmlFor={id} className="text-sm mb-1">
            {label}
          </label>
        )}

        <Select
          instanceId={id}
          placeholder={placeholder}
          aria-label={label}
          options={options}
          value={options.find((option) => option.value === value)}
          components={{
            DropdownIndicator: () => (
              <Icon id="dropdown-indicator" name="ChevronDown" />
            ),
          }}
          onChange={(option) => {
            onChange(option?.value ?? '')
          }}
          styles={getInputSearchDropdownStyles(
            !!errorMessage,
            hasBorder,
            styles,
          )}
        />

        {!!errorMessage && (
          <span role="alert" className="mt-2 text-xs text-error">
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  )
}

export default InputSearchDropdown
